module.exports = __webpack_public_path__ + "img/CRT_Spear-002.2bc779b3.png";